module.exports = __webpack_public_path__ + "static/media/report.1671963f.png";